import { StatusCodes } from '../../../Libs/http-status-codes'
import { User } from '../types'
import { ApiResult, AuthFetchError } from '../../../Types/api'
import axios, { AxiosError, isAxiosError } from 'axios'

export const checkRegistrationToken = async (token: string | undefined): Promise<ApiResult<User>> => {
  if (!token) {
    return new ApiResult<User, Error | AuthFetchError>(null, true, new Error('Token is missing'))
  }

  try {
    const url = (process.env.REACT_APP_API_ENDPOINT ?? '') + `/users/register/${token}`
    const response = await axios.get<User>(url)

    if (response.status === StatusCodes.OK) {
      return new ApiResult<User>(response.data, false)
    }

    return new ApiResult<User, AxiosError>(null, true)
  } catch (error) {
    if (error instanceof Error || isAxiosError(error)) {
      return new ApiResult<User, Error | AuthFetchError>(null, true, error as Error | AuthFetchError)
    }
    return new ApiResult<User, Error | AuthFetchError>(null, true)
  }
}
